import TYPES from '../../types';

// Domain
import { OccupationEntity } from '../../domain/entities/occupation-entity';
import { OccupationRepository } from '../../domain/repository/occupation-repository';
import { StateManager } from '../../domain/state/state-manager';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Query from '@/modules/shared/domain/use-cases/query';

@Injectable()
export default class SearchOccupationsQuery extends Query<Array<OccupationEntity>> {
  @Inject(TYPES.CATALOG_ALLIANZ_OCCUPATION_STATE_MANAGER)
  private readonly state_manager!: StateManager;

  @Inject(TYPES.CATALOG_ALLIANZ_OCCUPATION_REPOSITORY)
  private readonly repository!: OccupationRepository;

  internalExecute() {
    if (!this.state_manager.state.loaded) {
      this.repository.execute()
        .then((items) => {
          this.state_manager.patch({ items, loaded: true });
        });
    }

    return this.state_manager.state.items;
  }
}
